namespace Matrix.Data {
    export interface DataReportListParametersRequest extends Serenity.ServiceRequest {
        QueryType?: DataQueryType;
        ObjectName?: string;
        Sql?: string;
    }
}
